import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e222702"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row my-4" }
const _hoisted_3 = { class: "col-12 mb-2" }
const _hoisted_4 = { class: "col-md-8 col-xl-9" }
const _hoisted_5 = {
  key: 0,
  class: "display-4"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mb-0 mt-2" }, null, -1))
const _hoisted_7 = { class: "text-color-secondary text-right mb-3" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 0,
  class: "col-md-4 col-xl-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackButton = _resolveComponent("BackButton")!
  const _component_CallToActionSimpleBlock = _resolveComponent("CallToActionSimpleBlock")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_BackButton, {
          label: _ctx.$t('common.back')
        }, null, 8, ["label"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.article.title)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_5, _toDisplayString(_ctx.article.title), 1))
          : _createCommentVNode("", true),
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("small", null, _toDisplayString(_ctx.$t("common.lastModified", { date: _ctx.formatLongDate(_ctx.article.modifiedDate) })), 1)
        ]),
        _createElementVNode("p", {
          class: "rte",
          innerHTML: _ctx.article.description
        }, null, 8, _hoisted_8)
      ]),
      (_ctx.vm.questionBlockViewModel)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", {
              class: _normalizeClass({ 'sticky-sidebar': !_ctx.isSmallScreen })
            }, [
              _createVNode(_component_CallToActionSimpleBlock, {
                vm: _ctx.vm.questionBlockViewModel
              }, null, 8, ["vm"])
            ], 2)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}